<template>
  <div id="editor" :style="`height: ${height}px`"></div>
</template>

<script>
import Quill from 'quill'

export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    height: {
      type: Number,
      default: 160
    }
  },
  data() {
    return {
      quill: null,
    }
  },
  watch: {
    value() {
      if (this.quill.root.innerHTML !== this.value) {
        this.quill.root.innerHTML = this.value
      }
    },
  },
  mounted() {
    this.quill = new Quill('#editor', {
      modules: {
        toolbar: [
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          ['bold', 'italic', 'underline'],
          [{ list: 'ordered' }, { list: 'bullet' }],
          ['link', 'blockquote'],
          ['clean'],
        ]
      },
      placeholder: '',
      theme: 'snow',
    })

    this.quill.on('text-change', () => {
      this.$emit('input', this.quill.root.innerHTML)
    })

    this.quill.root.innerHTML = this.value
  }
}
</script>